import React,{useEffect,useState} from "react";
import {Link,useNavigate,useParams} from "react-router-dom";
import {api} from "@/lib/api";
import {toast} from "sonner";
export default function PCStockAllocatePage(){
 const {pcId}=useParams(),navigate=useNavigate();
 const [pc,setPc]=useState(null),[units,setUnits]=useState([]);
 const [busy,setBusy]=useState(false),[error,setError]=useState("");
 const [mismatchFields,setMismatchFields]=useState([]),[linkedMismatches,setLinkedMismatches]=useState([]);
 useEffect(()=>{
   let alive=true;
   (async()=>{
     try{
       const r=await api.get("/pcs/"+encodeURIComponent(pcId)+"/stock-allocation");
       if(!alive)return;
       setPc(r.data.pc);setLinkedMismatches(r.data.mismatch_fields||[]);
       const a=await api.get("/stock/available",{params:{pc_id:pcId}});
       if(alive){
         setUnits((a.data.units||[]).filter(u=>u.matches_specifications));
         const similar=(a.data.units||[]).filter(u=>String(u.container_type||"").trim().toLowerCase()===String(r.data.pc.container_type||"").trim().toLowerCase());
         setMismatchFields([...new Set(similar.flatMap(u=>u.mismatch_fields||[]))]);
       }
     }catch(e){if(alive)setError(e.response?.data?.detail||"Could not load stock")}
   })();return()=>{alive=false}
 },[pcId]);
 const allocate=async(unit)=>{
   if(!window.confirm("Allocate stock unit "+unit.stock_serial+" to this customer PC?"))return;
   setBusy(true);
   try{
     await api.post("/pcs/"+encodeURIComponent(pcId)+"/allocate-stock",{stock_unit_id:unit.id});
     toast.success("Stock linked; unit now unavailable for other customers");
     navigate("/pcs");
   }catch(e){toast.error(e.response?.data?.detail||"Stock allocation failed")}
   finally{setBusy(false)}
 };
 return <div className="mx-auto max-w-2xl space-y-4 pb-20">
   <Link to="/pcs" className="text-sm font-medium text-blue-600">← Back to My PCs</Link>
   <h1 className="text-2xl font-semibold">Allocate Existing Stock</h1>
   <p className="text-sm text-slate-600">Optional. Physical readiness is not verified in this release.</p>
   {error&&<div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>}
   {pc&&<div className="rounded-xl border bg-white p-4 text-sm">
     <b>PC {pc.pc_number} · {pc.customer_name}</b><div>{pc.container_type}</div>
     {pc.stock_unit_id&&<div className="text-emerald-700">Stock unit {pc.source_stock_serial} allocated</div>}
     {!!linkedMismatches.length&&<div className="mt-2 text-rose-700">Warning: this existing stock attachment has different container specifications: {linkedMismatches.join(", ")}. Ask Admin to review.</div>}
   </div>}
   {pc&&!pc.stock_unit_id&&<div className="space-y-3">
     <h2 className="font-semibold">Matching unallocated stock ({units.length})</h2>
     {units.map(u=><div key={u.id} className="flex items-center justify-between gap-3 rounded-xl border bg-white p-4">
       <div className="text-sm"><b>Stock unit {u.stock_serial}</b>
         <div className="text-slate-600">{u.stock_pc_reference} · {u.container_type}</div>
       </div>
       <button type="button" disabled={busy} onClick={()=>allocate(u)}
         className="shrink-0 rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white disabled:opacity-50">Allocate</button>
     </div>)}
     {!units.length&&<div className="rounded-xl border bg-white p-4 text-sm">No unallocated stock with the same container specifications. Container model, size, finishes, doors, core, insulation and floor must match.
       {!!mismatchFields.length&&<div className="mt-2 text-amber-700">Different fields in available stock: {mismatchFields.join(", ")}</div>}</div>}
   </div>}
   <Link to="/pcs" className="block rounded-xl border bg-white p-3 text-center text-sm font-semibold">Skip — Continue Without Stock</Link>
 </div>;
}

// fc-stock-conditional-button-spec-match-20261012
